import { c as _c } from "react/compiler-runtime";
import { Tooltip, toast } from '@systemeio/ui';
import { BadRequest, replaceWwwForHosts } from '@systemeio/util';
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { CUSTOM_DOMAINS_SETTINGS_API, editSubDomain, markAsDefault, removeLoginPage, removeNotFoundPage } from 'modules/profile/custom-domains-settings/api/custom-domain-api';
import CreateDomainModal from 'modules/profile/custom-domains-settings/components/create-domain-modal';
import DnsModal from 'modules/profile/custom-domains-settings/components/dns-modal';
import DomainSettingsModal from 'modules/profile/custom-domains-settings/components/domain-settings-modal';
import { getSubdomainFromDomain, SubdomainInput } from 'modules/profile/custom-domains-settings/components/subdomain-input';
import RemoveDomainModal from 'modules/profile/custom-domains-settings/components/remove-domain-modal';
import { CustomDomainsSettingsLoco } from 'modules/profile/custom-domains-settings/constants/custom-domains-settings-loco';
import { CustomDomainsStatusEnum } from 'modules/profile/custom-domains-settings/enums/custom-domains-settings-enum';
import { useCustomDomainsSettings } from 'modules/profile/custom-domains-settings/hooks/use-custom-domains-settings';
import { CustomDomainsSettingId, CustomDomainsSettingsInterface, CustomDomainsSubdomainEditInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface';
import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useWindowSize from 'shared/hooks/use-window-size';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { CheckIcon } from '@systemeio/ui/icons';
const CustomDomainsSettings: NextPage = () => {
  const $ = _c(127);
  const {
    t
  } = useLocoTranslation();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  let t0;
  if ($[0] !== setPagination) {
    t0 = {
      setPagination,
      api: CUSTOM_DOMAINS_SETTINGS_API
    };
    $[0] = setPagination;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const updateData = useUpdateData(t0);
  const [needToOpenDns, sdtNeedToOpenDns] = useState(undefined);
  const {
    width
  } = useWindowSize();
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      sdtNeedToOpenDns(undefined);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== width) {
    t2 = [width];
    $[3] = width;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== limit || $[6] !== pagination) {
    t3 = {
      pagination,
      limit
    };
    $[5] = limit;
    $[6] = pagination;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    customDomains,
    mutate,
    counter
  } = useCustomDomainsSettings(t3);
  const [subdomainError, setSubdomainError] = useState("");
  let t4;
  if ($[8] !== customDomains || $[9] !== updateData) {
    t4 = async domain => {
      await updateData(true, customDomains);
      sdtNeedToOpenDns(domain.id);
    };
    $[8] = customDomains;
    $[9] = updateData;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const createDomainWithUpdate = t4;
  let t5;
  if ($[11] !== customDomains || $[12] !== updateData) {
    t5 = async () => {
      sdtNeedToOpenDns(undefined);
      await updateData(false, customDomains);
    };
    $[11] = customDomains;
    $[12] = updateData;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const removeDomainWithUpdate = t5;
  let t6;
  if ($[14] !== customDomains || $[15] !== mutate || $[16] !== updateData) {
    t6 = async domain_0 => {
      ;
      try {
        sdtNeedToOpenDns(undefined);
        await markAsDefault(domain_0.id);
        await updateData(false, undefined, {
          mutationData: customDomains,
          onMutate: async () => {
            await mutate(data => {
              if (data) {
                return {
                  items: data.items.map(el => {
                    if (el.id === domain_0.id) {
                      el.defaultDomain = true;
                    } else {
                      if (el.defaultDomain) {
                        el.defaultDomain = false;
                      }
                    }
                    return {
                      ...el
                    };
                  }),
                  hasMore: data.hasMore
                };
              }
            }, false);
          }
        });
      } catch (t7) {
        const e = t7;
        throw e;
      }
    };
    $[14] = customDomains;
    $[15] = mutate;
    $[16] = updateData;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const onMarkAsDefault = t6;
  let t7;
  if ($[18] !== t) {
    t7 = t("dashboard.settings.custom_domains.domain_name");
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t) {
    t8 = customDomain => <div className="flex flex-col gap-1 overflow-hidden"><div className="flex items-center gap-1.5">{customDomain.status === CustomDomainsStatusEnum.active ? <a className="primary-link h-fit w-full truncate" href={`${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${customDomain.domainName}`} rel="noreferrer" target="_blank">{customDomain.domainName}</a> : <span className="h-fit w-full truncate">{customDomain.domainName}</span>}{customDomain.defaultDomain && <Tooltip mode="hover" label={t("dashboard.settings.custom_domains.default_domain")}><CheckIcon className="stroke-green" /></Tooltip>}</div></div>;
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = {
      key: "domainName",
      header: t7,
      widthPercent: 40,
      onRender: t8
    };
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("global.status");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  let t12;
  if ($[27] !== needToOpenDns || $[28] !== width) {
    t11 = customDomain_0 => <DnsModal needToOpenDns={width >= 1024 ? needToOpenDns : undefined} domain={customDomain_0} />;
    t12 = customDomain_1 => <DnsModal needToOpenDns={width < 1024 ? needToOpenDns : undefined} domain={customDomain_1} />;
    $[27] = needToOpenDns;
    $[28] = width;
    $[29] = t11;
    $[30] = t12;
  } else {
    t11 = $[29];
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12) {
    t13 = {
      key: "status",
      header: t10,
      widthPercent: 40,
      onRender: t11,
      onRenderSmall: t12
    };
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t13 || $[36] !== t9) {
    t14 = [t9, t13];
    $[35] = t13;
    $[36] = t9;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const customDomainsColumns = t14;
  let t15;
  if ($[38] !== customDomains || $[39] !== mutate || $[40] !== updateData) {
    t15 = async domain_1 => {
      ;
      try {
        sdtNeedToOpenDns(undefined);
        await removeLoginPage(domain_1.id);
        await updateData(false, undefined, {
          mutationData: customDomains,
          onMutate: async () => {
            await mutate(data_0 => {
              if (data_0) {
                return {
                  hasMore: data_0.hasMore,
                  items: data_0.items.map(el_0 => {
                    if (el_0.id === domain_1.id) {
                      el_0.loginPage = null;
                    }
                    return {
                      ...el_0
                    };
                  })
                };
              }
            }, false);
          }
        });
      } catch (t16) {
        const e_0 = t16;
        throw e_0;
      }
    };
    $[38] = customDomains;
    $[39] = mutate;
    $[40] = updateData;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  const onRemoveLoginPage = t15;
  let t16;
  if ($[42] !== customDomains || $[43] !== mutate || $[44] !== updateData) {
    t16 = async domain_2 => {
      ;
      try {
        sdtNeedToOpenDns(undefined);
        await removeNotFoundPage(domain_2.id);
        await updateData(false, undefined, {
          mutationData: customDomains,
          onMutate: async () => {
            await mutate(data_1 => {
              if (data_1) {
                return {
                  hasMore: data_1.hasMore,
                  items: data_1.items.map(el_1 => {
                    if (el_1.id === domain_2.id) {
                      el_1.notFoundPage = null;
                    }
                    return {
                      ...el_1
                    };
                  })
                };
              }
            }, false);
          }
        });
      } catch (t17) {
        const e_1 = t17;
        throw e_1;
      }
    };
    $[42] = customDomains;
    $[43] = mutate;
    $[44] = updateData;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  const onRemoveNotFoundPage = t16;
  let t17;
  if ($[46] !== mutate || $[47] !== t) {
    t17 = async (id, subdomain) => {
      ;
      try {
        setSubdomainError("");
        sdtNeedToOpenDns(undefined);
        const newData = {
          name: subdomain
        };
        await editSubDomain(id, newData);
        await mutate(domains => {
          if (domains) {
            return {
              hasMore: domains.hasMore,
              items: domains.items.map(el_2 => {
                if (el_2.id === id) {
                  el_2.domainName = `${subdomain}.${replaceWwwForHosts(window.location.host)}`;
                }
                return {
                  ...el_2
                };
              })
            };
          }
        }, false);
        toast.success(t("global.changes_saved"));
      } catch (t18) {
        const e_2 = t18;
        if (e_2 instanceof BadRequest && e_2.errors.fields) {
          setSubdomainError(e_2.errors.fields.name?.join(""));
        }
        throw e_2;
      }
    };
    $[46] = mutate;
    $[47] = t;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  const onEditSubdomain = t17;
  let t18;
  if ($[49] !== customDomains || $[50] !== mutate || $[51] !== updateData) {
    t18 = async newData_0 => {
      ;
      try {
        sdtNeedToOpenDns(undefined);
        await updateData(false, undefined, {
          mutationData: customDomains,
          onMutate: async () => {
            await mutate(data_2 => {
              if (data_2) {
                return {
                  items: data_2.items.map(item => {
                    if (item.id === newData_0.id) {
                      item = {
                        ...item,
                        ...newData_0
                      };
                    }
                    return item;
                  }),
                  hasMore: data_2.hasMore
                };
              }
            }, false);
          }
        });
      } catch (t19) {
        const e_3 = t19;
        throw e_3;
      }
    };
    $[49] = customDomains;
    $[50] = mutate;
    $[51] = updateData;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  const editDomainWithUpdate = t18;
  let t19;
  if ($[53] !== t) {
    t19 = t(settingsMenuLocoKeys.custom_domains);
    $[53] = t;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t19) {
    t20 = [{
      caption: t19,
      isStatic: true
    }];
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== createDomainWithUpdate) {
    t21 = <CreateDomainModal createDomainWithUpdate={createDomainWithUpdate} />;
    $[57] = createDomainWithUpdate;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== t) {
    t22 = t(settingsMenuLocoKeys.custom_domains);
    $[59] = t;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== t) {
    t23 = t("dashboard.settings.custom_domains.edit_homepage");
    $[61] = t;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== t23) {
    t24 = [{
      name: "edit-homepage",
      shouldRender: _temp,
      caption: t23,
      setHref: _temp2,
      openInNew: false
    }];
    $[63] = t23;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] !== t) {
    t25 = t("dashboard.settings.custom_domains.edit_subdomain");
    $[65] = t;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== onEditSubdomain || $[68] !== subdomainError || $[69] !== t) {
    t26 = (opened, onClose, instance, key) => <EditModal fullCaption={t("dashboard.settings.custom_domains.edit_sio_subdomain")} key={key} opened={opened} onClose={onClose} instance={instance} editable={[{
      field: "domainName",
      onRender: (value, onChange) => <SubdomainInput key="subdomain-edit" error={subdomainError} subdomain={getSubdomainFromDomain(value) ?? ""} onChange={onChange} />
    }]} onEdit={async data_3 => {
      const subdomain_0 = getSubdomainFromDomain(data_3.domainName);
      if (!subdomain_0) {
        return;
      }
      await onEditSubdomain(instance.id, subdomain_0);
    }} />;
    $[67] = onEditSubdomain;
    $[68] = subdomainError;
    $[69] = t;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t25 || $[72] !== t26) {
    t27 = {
      shouldRender: _temp3,
      name: "edit-subdomain-name",
      caption: t25,
      onActionRender: t26
    };
    $[71] = t25;
    $[72] = t26;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  let t28;
  if ($[74] !== t) {
    t28 = t("dashboard.settings.custom_domains.make_default_domain");
    $[74] = t;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] !== onMarkAsDefault || $[77] !== t) {
    t29 = (opened_0, onClose_0, instance_0, key_0) => <ConfirmationModal opened={opened_0} onClose={onClose_0} key={key_0} onConfirm={() => onMarkAsDefault(instance_0)} confirmationText={t("dashboard.settings.custom_domains.make_default_domain")} />;
    $[76] = onMarkAsDefault;
    $[77] = t;
    $[78] = t29;
  } else {
    t29 = $[78];
  }
  let t30;
  if ($[79] !== t28 || $[80] !== t29) {
    t30 = {
      shouldRender: _temp4,
      name: "set-default",
      caption: t28,
      onActionRender: t29
    };
    $[79] = t28;
    $[80] = t29;
    $[81] = t30;
  } else {
    t30 = $[81];
  }
  let t31;
  if ($[82] !== t) {
    t31 = t("dashboard.actions.title.settings");
    $[82] = t;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== editDomainWithUpdate || $[85] !== onRemoveLoginPage || $[86] !== onRemoveNotFoundPage) {
    t32 = (opened_1, onClose_1, instance_1, key_1) => <DomainSettingsModal editDomainWithUpdate={editDomainWithUpdate} domain={instance_1} opened={opened_1} onClose={onClose_1} key={key_1} onRemoveLoginPage={onRemoveLoginPage} onRemoveNotFoundPage={onRemoveNotFoundPage} />;
    $[84] = editDomainWithUpdate;
    $[85] = onRemoveLoginPage;
    $[86] = onRemoveNotFoundPage;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t31 || $[89] !== t32) {
    t33 = {
      name: "domain-settings",
      caption: t31,
      onActionRender: t32
    };
    $[88] = t31;
    $[89] = t32;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  let t34;
  if ($[91] !== t) {
    t34 = t("dashboard.actions.title.remove");
    $[91] = t;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  let t35;
  if ($[93] !== removeDomainWithUpdate) {
    t35 = (opened_2, onClose_2, instance_2, key_2) => <RemoveDomainModal opened={opened_2} onClose={onClose_2} domain={instance_2} removeDomainWithUpdate={removeDomainWithUpdate} key={key_2} />;
    $[93] = removeDomainWithUpdate;
    $[94] = t35;
  } else {
    t35 = $[94];
  }
  let t36;
  if ($[95] !== t34 || $[96] !== t35) {
    t36 = {
      name: "domain-remove",
      caption: t34,
      shouldRender: _temp5,
      onActionRender: t35
    };
    $[95] = t34;
    $[96] = t35;
    $[97] = t36;
  } else {
    t36 = $[97];
  }
  let t37;
  if ($[98] !== t27 || $[99] !== t30 || $[100] !== t33 || $[101] !== t36) {
    t37 = [t27, t30, t33, t36];
    $[98] = t27;
    $[99] = t30;
    $[100] = t33;
    $[101] = t36;
    $[102] = t37;
  } else {
    t37 = $[102];
  }
  let t38;
  if ($[103] !== t24 || $[104] !== t37) {
    t38 = {
      openLink: t24,
      custom: t37
    };
    $[103] = t24;
    $[104] = t37;
    $[105] = t38;
  } else {
    t38 = $[105];
  }
  let t39;
  if ($[106] !== limit || $[107] !== setLimit) {
    t39 = {
      limit,
      setLimit
    };
    $[106] = limit;
    $[107] = setLimit;
    $[108] = t39;
  } else {
    t39 = $[108];
  }
  let t40;
  if ($[109] !== pagination || $[110] !== setPagination) {
    t40 = {
      pagination,
      setPagination
    };
    $[109] = pagination;
    $[110] = setPagination;
    $[111] = t40;
  } else {
    t40 = $[111];
  }
  let t41;
  if ($[112] !== customDomains || $[113] !== customDomainsColumns || $[114] !== t38 || $[115] !== t39 || $[116] !== t40) {
    t41 = <Table actions={t38} data={customDomains} columns={customDomainsColumns} limiter={t39} paginator={t40} emptyListWithTitles={true} />;
    $[112] = customDomains;
    $[113] = customDomainsColumns;
    $[114] = t38;
    $[115] = t39;
    $[116] = t40;
    $[117] = t41;
  } else {
    t41 = $[117];
  }
  let t42;
  if ($[118] !== counter || $[119] !== customDomains || $[120] !== t22 || $[121] !== t41) {
    t42 = <div className="bg-background-secondary h-fit w-full rounded-lg p-5"><ListingLayout data={customDomains} title={t22} titleClassName="font-semibold" type="compact" counter={counter}>{t41}</ListingLayout></div>;
    $[118] = counter;
    $[119] = customDomains;
    $[120] = t22;
    $[121] = t41;
    $[122] = t42;
  } else {
    t42 = $[122];
  }
  let t43;
  if ($[123] !== t20 || $[124] !== t21 || $[125] !== t42) {
    t43 = <SettingsLayout needSave={false} titles={t20} customHeader={t21}>{t42}</SettingsLayout>;
    $[123] = t20;
    $[124] = t21;
    $[125] = t42;
    $[126] = t43;
  } else {
    t43 = $[126];
  }
  return t43;
};
export const getServerSideProps = getBaseServerSideProps(CustomDomainsSettingsLoco, 'global.settings');
export default CustomDomainsSettings;
function _temp(customDomain_2) {
  return !!customDomain_2.homePageEditUrl;
}
function _temp2(customDomain_3) {
  return customDomain_3.homePageEditUrl || "";
}
function _temp3(domain_3) {
  return domain_3.type === "sio_subdomain";
}
function _temp4(customDomain_4) {
  return !customDomain_4.defaultDomain && customDomain_4.status === CustomDomainsStatusEnum.active;
}
function _temp5(domain_4) {
  return domain_4.type === "aws" && domain_4.status !== CustomDomainsStatusEnum.aws_remove_in_progress;
}